import { merge } from 'lodash';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { ApiFilterOperation, EvidenceProps, Filter } from '@eas/common-web';
import { useDefaultIndexRole } from '@modules/role/role-api';
import { StaticDataContext } from '@components/evidence/static-data-provider/static-data-provider';
import { SprFile } from '@models';
import { Agenda, EsFileState } from '@enums';
import { disableBtnFactory } from '../es-file/es-file-utils';
import { useEsFiles } from '../es-file/es-files';

export const SPR_FILES_IDENTIFIER = 'SPR_FILES';
export const SPR_FILES_VERSION = 10;

export function useSprFiles({
  evidenceProps,
}: {
  evidenceProps?: Partial<EvidenceProps<SprFile>>;
}) {
  const intl = useIntl();

  const { defaultSettlementMethods } = useContext(StaticDataContext);
  const [defaultSprIndexRole] = useDefaultIndexRole(Agenda.SPR);

  const defaultSettlementMethod = defaultSettlementMethods.find(
    (method) => method.agenda === Agenda.SPR
  );

  const defaultPreFilters = [
    ...((evidenceProps?.tableProps?.defaultPreFilters ?? []) as Filter[]),
    {
      field: 'agenda.id',
      operation: ApiFilterOperation.EQ,
      value: Agenda.SPR,
    },
  ];

  const defaultSprFile = {
    id: uuidv4(),
    created: new Date().toISOString(),
    agenda: Agenda.SPR,
    state: EsFileState.NEW,
    settlementMethods: defaultSettlementMethod ? [defaultSettlementMethod] : [],
    incomingNumber: `SPR-TEST-${Math.ceil(Math.random() * 1000)}`,
    deliveryDate: new Date().toISOString(),
    indexUserRole: defaultSprIndexRole!,
  };

  const props = merge(
    {
      evidenceProps: {
        identifier: SPR_FILES_IDENTIFIER,
        version: SPR_FILES_VERSION,
        tableProps: {
          defaultPreFilters,
          tableName: intl.formatMessage({
            id: 'ES__SPR_FILES__TABLE__TITLE',
            defaultMessage: 'Spisy SPR',
          }),
        },
        detailProps: {
          toolbarProps: {
            title: intl.formatMessage({
              id: 'ES__SPR_FILES__DETAIL__TITLE',
              defaultMessage: 'Spis SPR',
            }),
            disableBtn: disableBtnFactory(defaultSprFile),
          },
          initNewItem: () => defaultSprFile,
        },
      },
    },
    { evidenceProps }
  );

  return useEsFiles(props);
}
